import React, { useEffect, useState } from 'react';
import { X, Loader, Check } from 'lucide-react';
import { apiClient } from '../utils/apiClient';

/**
 * Snapshot-3.0-Banner: pollt den Character-Sheet-Status.
 * Mountet sich automatisch über `pending_avatar_id` aus localStorage
 * (gesetzt vom Wizard nach POST /api/avatar/create).
 *
 * Optionale Props:
 *   avatarId  — explizit setzen (überschreibt localStorage)
 *   onDone()  — Callback bei status='ready'
 */
const TrainingBanner = ({ avatarId: propAvatarId, onDone }) => {
  const [avatarId, setAvatarId] = useState(propAvatarId || null);
  const [status, setStatus] = useState('generating');
  const [dismissed, setDismissed] = useState(false);

  // localStorage-fallback (wenn nicht explizit als prop gesetzt)
  useEffect(() => {
    if (propAvatarId) { setAvatarId(propAvatarId); return; }
    const fromLs = localStorage.getItem('pending_avatar_id');
    if (fromLs) setAvatarId(fromLs);
  }, [propAvatarId]);

  useEffect(() => {
    if (!avatarId || dismissed) return;
    let cancelled = false;

    const tick = async () => {
      try {
        const res = await apiClient.get(`/api/avatar/${avatarId}/status`);
        if (!res.ok || cancelled) return;
        const data = await res.json();
        const s = data.character_sheet_status || data.status;
        setStatus(s);
        if (s === 'ready') {
          localStorage.removeItem('pending_avatar_id');
          if (onDone) onDone(data);
        }
        if (s === 'failed') {
          localStorage.removeItem('pending_avatar_id');
        }
      } catch (e) {
        console.warn('avatar status poll failed', e);
      }
    };

    tick();
    const id = setInterval(tick, 5000);
    return () => { cancelled = true; clearInterval(id); };
  }, [avatarId, dismissed, onDone]);

  if (!avatarId || dismissed) return null;
  if (status === 'ready') return null;

  const isFailed = status === 'failed';

  return (
    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md px-4 pointer-events-none">
      <div className={`pointer-events-auto bg-black border-2 ${isFailed ? 'border-red-500' : 'border-[#10B981]'} rounded-2xl p-4 shadow-2xl`}>
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center gap-2">
            {isFailed ? (
              <X className="w-5 h-5 text-red-500" />
            ) : (
              <Loader className="w-5 h-5 text-[#10B981] animate-spin" />
            )}
            <h3 className="text-white font-bold text-sm">
              {isFailed ? 'Avatar-Erstellung fehlgeschlagen' : 'Dein Avatar wird vorbereitet ...'}
            </h3>
          </div>
          <button onClick={() => setDismissed(true)} className="text-white/50 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-white/60 text-xs">
          {isFailed
            ? 'Deine SNAPs wurden zurückerstattet. Du kannst es gleich nochmal versuchen.'
            : 'Nur noch ein bisschen Geduld, dann kannst du mit dem Erstellen von Bildern und Videos beginnen.'}
        </p>
      </div>
    </div>
  );
};

export default TrainingBanner;
